import { type ProjectPageProps } from "@op/puck-types";
import { Ow_Project_Hero } from "@op/sf-op";
import Medium from "../../../../../components/puck/Medium/Medium";
import { useMemo } from "react";
import { TopicSection } from "./ProjectPage/TopicSection";
import { DefaultLinkComponent, ThemeNav } from "./ThemeNav";
import { ThemeFooter } from "./ThemeFooter";

const ProjectPage = ({
  languageKey,
  topics,
  LinkComponent = DefaultLinkComponent,
  languages,
  heading,
  subheading,
  logoImage,
  imprintLink,
  privacyLink,
  copyrightText,
  hasImprint,
  hasPrivacyPolicy,
  brandElement,
  organizationName,
  organizationLink,
}: ProjectPageProps) => {
  const showHero = useMemo(
    () => !!heading || !!subheading,
    [heading, subheading],
  );

  return (
    <div className="min-h-screen flex flex-col justify-between items-center">
      <div className="w-full flex flex-col justify-center items-center">
        <ThemeNav
          languageKey={languageKey}
          languages={languages}
          logoImage={logoImage}
          organizationName={organizationName}
          organizationLink={organizationLink}
          LinkComponent={LinkComponent}
        />
        {showHero ? (
          <div className="flex flex-col w-full max-w-[1024px] mt-24 px-8 py-16">
            <Ow_Project_Hero
              title={heading}
              description={subheading}
              brandElementSlot={
                brandElement && <Medium cover medium={brandElement} />
              }
            />
          </div>
        ) : (
          <div className="h-32" />
        )}
        {topics.map((topic, idx) => (
          <TopicSection
            key={topic.id}
            {...topic}
            noAccent={idx % 2 === 0}
            languageKey={languageKey}
            LinkComponent={LinkComponent}
          />
        ))}
      </div>
      <ThemeFooter
        copyrightText={copyrightText}
        imprintLink={imprintLink}
        privacyLink={privacyLink}
        hasImprint={hasImprint}
        hasPrivacyPolicy={hasPrivacyPolicy}
        languageKey={languageKey}
        LinkComponent={LinkComponent}
      />
    </div>
  );
};

export default ProjectPage;
